import BlDataTableMv from './BlDataTableMv.vue'

BlDataTableMv.install = function(Vue) {
  Vue.component(BlDataTableMv.name, BlDataTableMv)
}

export default BlDataTableMv
